import {DashboardWidgetDescriptor} from "./DashboardWidget";
import {AliveListWidget} from "./AliveListWidget";
import {FinishedListWidget} from "./FinishedListWidget";
import {JournalWidget} from "./JournalWidget";
import {WidgetRegistry} from "./WidgetRegistry";

const DESCRIPTORS: DashboardWidgetDescriptor[] = [
	{
		id: AliveListWidget.WAITING_ID,
		titleCode: 'dashboard.listLiveWaiting.caption',
		create: (context, content) => new AliveListWidget(context, content, 'waiting')
	},
	{
		id: AliveListWidget.WORKING_ID,
		titleCode: 'dashboard.listLiveWorking.caption',
		create: (context, content) => new AliveListWidget(context, content, 'working')
	},
	{
		id: FinishedListWidget.ID,
		titleCode: 'dashboard.listFinished.caption',
		create: (context, content) => new FinishedListWidget(context, content)
	},
	{
		id: JournalWidget.ID,
		titleCode: 'dashboard.widgets.journal.caption',
		authorities: ['journal:view'],
		defaultRoles: ['tech', 'service', 'admin'],
		create: (context, content) => new JournalWidget(context, content)
	}
]

export function createDashboardWidgetRegistry(): WidgetRegistry {
	const registry = new WidgetRegistry()
	DESCRIPTORS.forEach(d => registry.register(d))
	return registry
}
